// extracted by mini-css-extract-plugin
export var chip = "_c7-0";
export var filterDropdown = "_c7-5";
export var filterItem = "_c7-6";
export var icon = "_c7-1";
export var removeButton = "_c7-3";
export var removeIcon = "_c7-4";
export var separator = "_c7-2";